import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import ReferralOrdersList from './ReferralOrdersList'

export default function ReferralOrders() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/referral_orders" component={ReferralOrdersList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}